import Glide from 'glidejs'
import { initCountdown } from '../global/countdown'
import manualModalOpen from '../sections/product/manualModalOpen'

const addBarElement = (barClasses, countdownClasses, block, barsContainer) => {
  const barElem = document.createElement('li')
  const {
    text,
    bgColor,
    textColor,
    displayCountdown,
    countdownYear,
    countdownMonth,
    countdownDay,
    countdownHour,
    countdownMinute,
    countdownSecond,
    sizeChartEnabled
  } = block

  barClasses.forEach(barClass => {
    barElem.classList.add(barClass)
  })

  if(sizeChartEnabled){
    barElem.classList.add('trigger-size-guide');
    barElem.style.cursor = 'pointer';
  }

  barElem.innerHTML = text
  barElem.style.backgroundColor = bgColor
  barElem.style.color = textColor

  if (displayCountdown) {
    const countdownElem = document.createElement('div')

    countdownClasses.forEach(countdownClass => {
      countdownElem.classList.add(countdownClass)
    })

    const dateStr = `${countdownMonth} ${countdownDay}, ${countdownYear} ${countdownHour}:${countdownMinute}:${countdownSecond}`
    const date = new Date(dateStr).getTime()

    initCountdown(date, countdownElem)
    
    barElem.append(countdownElem)
  }

  barsContainer.append(barElem)
}

const announcementsInit = () => {
  const announcementSections = document.querySelectorAll('[data-announcements]')

  if (!announcementSections) return false

  announcementSections.forEach(section => {
    const blocks = JSON.parse(section.dataset.announcements)
    const barClasses = section.dataset.barClasses.split(', ')
    const countdownClasses = section.dataset.countdownClasses.split(', ')

    const applicableBlocks = blocks.filter(settings => {
      const countries = settings.countryList.split(',').map(country => country.trim())
      return countries.includes(window.blubolt.geo.handle) || settings.global
    })

    const announcementGlide = section.querySelector('[data-announcement-glide]')
    const announcementSlides = section.querySelector('[data-announcement-slides]')

    if (applicableBlocks.length > 0) {
      applicableBlocks.forEach(block => {
        addBarElement(barClasses, countdownClasses, block, announcementSlides)
      })

      const glideConfig = {
        type: 'slider',
        startAt: 0,
        autoplay: 10000,
        perView: 1,
        gap: 0,
        rewind: true,
        animationDuration: 250,
        animationTimingFunc: 'linear'
      }
  
      // Custom initialization for these, as we need to wait for the populated elements above for the calculations to be right
      new Glide(announcementGlide, glideConfig).mount()

      manualModalOpen();
    }
  })
}
export default announcementsInit